import React from 'react'
import {withStyles} from 'material-ui'
import ReactMarkdown from 'react-markdown'

import {
    LandingPage,
    LandingHero,
    LandingCover,
    LandingBody,
    LandingHeroText,
    LandingVideo,
    LandingText,
    LandingSignup,
} from './landinglib'
import SignupForm from './SignupForm'

const styles = theme => ({
    center: {
        display: 'block',
        margin: '0 auto',
    },
    last: {
        textAlign: 'center'
    }
})

export const Landing = withStyles(styles)(
    ({classes}) => (
        <LandingPage title="Carefol.io | for caregivers">
            <LandingHero>
                <LandingCover src="/img/pills-pill-container_925x.jpg" dark="0.5"/>
                <LandingHeroText>
                    <ReactMarkdown source={`
# Stay up to date

Isn't it a hassle when you have to go to a new doctor?
You have to fill out forms, forms, and more forms.

Do you have any allergies? What are they? How severe?
What medicines do you take? What dosage? How long have you been taking them?
Who are all the other doctors you see? What are their phone numbers? Why are you seeing them?
What's your insurance information? What pharmacy do you use? What is their phone number?
Who is your emergency contact? What's their number?

It can be overwhelming. And we haven't even mentioned the legal paperwork that someone is going
to have to find if you have an emergency.

Carefol.io can help.
                    `}/>
                    <LandingVideo />
                </LandingHeroText>
                <LandingSignup />
            </LandingHero>
            <LandingBody>
                <LandingText>
                    <ReactMarkdown source={`
What if there was a **easy-to-use** solution that kept all this information **up-to-date**,
that stored it **securely**, and that could be accessed even over your smart phone so it could
**never be lost**?

Something that lets you **save**, **organize**, and easily **find** the information you need?
                    `}/>
                </LandingText>
                <LandingText>
                    <ReactMarkdown source={`
## Well, now there is.

Carefol.io Family Edition is an **easy-to-use** health platform that you use over the computer or over your
smartphone that helps you **save**, **organize**, and easily **find** the information you need, when and
where you need it.

But what if there *is* an emergency? Carefol.io has you covered there, too, with a printable health summary you
can keep on your refrigerator so that the important information is there in the event of an emergency.

You can even share access to your Carefol.io account with a trusted family member so that if something
happens to you, they have the information they need to help.
                    `}/>
                </LandingText>
                <LandingText className={classes.last}>
                    <h2>Carefol.io Family Edition is available risk-free for 30 days, with no credit card required.</h2>
                    <p>Sign up today, and the next time you see a new doctor, you'll know you've got it covered.</p>
                </LandingText>
                <LandingSignup className={classes.center}/>
            </LandingBody>
        </LandingPage>
    )
)

export default Landing


// WEBPACK FOOTER //
// ./src/components/Landing3.jsx